import { Fragment } from 'react'
import Link from 'next/link'
import slugify from 'slugify'

import Wrapper from 'components/saquon/wrapper'
import Dots from 'components/saquon/dots'
import { GlowHeading, Typography, Button, Grid } from '~ui'
import { auctions } from '../data'

import styles from './Auctions.module.scss'

const { Text } = Typography

const Card = ({ imgSrc, title, meta }) => (
  <div className={styles.card}>
    <div className={styles.image}>
      <img src={imgSrc} alt={title} />
    </div>
    <Grid textAlign="center" gridAutoFlow="row" className={styles.meta}>
      <Text size="lg" color="g-gray-6" bold center>
        {title}
      </Text>
      {meta.map((text) => (
        <Text key={text} color="purple" bold center>
          {text}
        </Text>
      ))}
    </Grid>
  </div>
)

const Package = ({ title, imgSrc, link }) => (
  <div className={styles.package}>
    <div className={styles.left}>
      <img width={92} height={92} src={imgSrc} alt={title} />
      <Text color="g-white" size="lg" bold>
        {title}
      </Text>
    </div>

    <div className={styles.right}>
      <Link href={link} legacyBehavior>
        <a>
          <Button variant="primary" tabIndex={-1}>
            Place bid
          </Button>
        </a>
      </Link>
    </div>
  </div>
)

const AuctionsSection = () => (
  <section style={{ overflow: 'hidden' }}>
    <Wrapper>
      <div className={styles.wrapper}>
        <Dots id={styles['dots-1']} className={styles['dots-1']} type="circle" />
        <Dots id={styles['dots-2']} className={styles['dots-2']} type="circle" />
        <Grid textAlign="center" className={styles.top} gap={16}>
          <GlowHeading Tag="h2" color="green" center uppercase>
            HOME GAME AUCTIONS
          </GlowHeading>
          <Text size="lg" color="g-white" center>
            Choose your favorite Access Package(s) and get more details by selecting ‘Place Bid’
            next to your preferred selection.
          </Text>
          <Text color="g-green" center>
            *Each home game offers 3 unique experiences
          </Text>
        </Grid>
        <div className={styles.body}>
          <div className={styles.auctions}>
            {auctions.map((item, index) => (
              <Fragment key={item.link}>
                <div id={slugify(item.title)} key={slugify(item.title)} className={styles.auction}>
                  <div className={styles.left}>
                    <Card {...item} />
                  </div>
                  <div className={styles.right}>
                    <div className={styles.packages}>
                      {item.packages.map((i) => (
                        <Package key={i.link} {...item} />
                      ))}
                    </div>
                    <Link href="#gameday" legacyBehavior>
                      <a className={styles.link}>Compare packages</a>
                    </Link>
                  </div>
                </div>
                {index !== auctions.length - 1 && <div className={styles.separator} />}
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </Wrapper>
  </section>
)

export default AuctionsSection
